// extracted by mini-css-extract-plugin
export var linkText = "_mg-0";